import ReactDom from 'react-dom';
import Card from '../Card/Card';
import OButton from '../FormControls/OButton';
import './Modal.css';

function Backdrop(props) {
  return <div className="backdrop" onClick={props.onClose} />;
}

function ModalOverlay(props) {
  const { title, message, type, onClose, onConfirm, condition } = props;
  let color = '#022760';
  let buttons = (
    <OButton
      className="modal-button"
      style={{ borderColor: color, background: color }}
      onClick={onClose}
      text="OK"
      startIcon={<i className="fas fa-check" />}
    />
  );

  if (type === 'warning') {
    color = '#022760';
    buttons = (
      <span>
        <OButton
          className="modal-button"
          style={{
            borderColor: color,
            background: color,
            marginRight: '7px',
          }}
          onClick={onConfirm}
          text={t(buttons.accept)}
          startIcon={<i className="fas fa-check" />}
        />
        <OButton
          className="modal-button"
          style={{
            borderColor: color,
            background: 'transparent',
            color,
          }}
          onClick={onClose}
          text="Poništi"
          startIcon={<i className="fas fa-times" />}
        />
      </span>
    );
  } else if (type === 'error') {
    color = '#dd4f3d';
    buttons = (
      <OButton
        className="modal-button"
        style={{ borderColor: color, background: color }}
        onClick={onClose}
        text="OK"
        startIcon={<i className="fas fa-check" />}
      />
    );
  } else if (type === 'edit' || type === 'form') {
    color = '#022760';
    buttons = (
      <span>
        <OButton
          className="modal-button"
          disabled={condition}
          style={{
            borderColor: color,
            background: color,
            marginRight: '7px',
          }}
          onClick={onConfirm}
          text={t(buttons.accept)}
          startIcon={<i className="fas fa-check" />}
        />
        <OButton
          className="modal-button"
          style={{
            borderColor: color,
            background: 'transparent',
            color,
          }}
          onClick={onClose}
          text="Poništi"
          startIcon={<i className="fas fa-times" />}
        />
      </span>
    );
  } else if (type === 'grid' || type === 'gridSearch') {
    color = '#0f8ec9';
    buttons = null;
  } else if (type === 'drag&drop') {
    color = '#0f8ec9';
    buttons = (
      <OButton
        className="modal-button"
        style={{ borderColor: color, background: color }}
        onClick={onClose}
        text="OK"
        startIcon={<i className="fas fa-check" />}
      />
    );
  } else if (type === 'email') {
    color = '#0f8ec9';
    buttons = (
      <OButton
        className="modal-button"
        style={{ borderColor: color, background: color }}
        onClick={onConfirm}
        text="OK"
        startIcon={<i className="fas fa-paper-plane" />}
      />
    );
  } else if (type === 'chose') {
    color = '#0f8ec9';
    buttons = (
      <span>
        <OButton
          className="modal-button"
          style={{
            borderColor: color,
            background: 'transparent',
            color,
          }}
          onClick={onClose}
          text="Poništi"
          startIcon={<i className="fas fa-times" />}
        />
      </span>
    );
  }

  return (
    <div>
      <Card
        className={
          type === 'grid'
            ? 'modalGrid'
            : type === 'gridSearch'
            ? 'gridSearch'
            : type === 'email'
            ? 'emailModal'
            : type === 'form'
            ? 'formModal'
            : 'modal'
        }
      >
        <header className="modal-header" style={{ backgroundColor: color }}>
          <h2>{title}</h2>
        </header>
        <div
          className="content"
          style={{ height: type === 'form' ? '400px' : null }}
        >
          {type === 'edit' ||
          type === 'loadEdit' ||
          type === 'grid' ||
          type === 'gridSearch' ||
          type === 'drag&drop' ||
          type === 'email' ||
          type === 'activity' ||
          type === 'chose' ||
          type === 'form' ? (
            <div>{message}</div>
          ) : (
            <div>{message}</div>
          )}
        </div>
        <footer className="modal-actions">{buttons}</footer>
      </Card>
    </div>
  );
}

function Modal(props) {
  return (
    <>
      {ReactDom.createPortal(
        <Backdrop onClose={props.onClose} />,
        document.getElementById('backdrop-root'),
      )}
      {ReactDom.createPortal(
        <ModalOverlay
          title={props.title}
          message={props.message}
          type={props.type}
          onConfirm={props.onConfirm}
          condition={props.condition}
          onLoad={props.onLoad}
          onClose={props.onClose}
          userId={props.userId}
          onEdit={props.onEdit}
          onDelete={props.onDelete}
        />,
        document.getElementById('overlay-root'),
      )}
    </>
  );
}

export default Modal;
